import React from "react";

function CardWithImage({ title, data }) {
  const lastMonthGrowth = parseInt(data?.prev_month_growth);
  const stringNumber = parseInt(data?.prev_month_growth);

  return (
    <div className="cardContainer">
      <div className="cardHeadingTwik">
        <h5 className="cardHeadingTwikTitle">{title}</h5>
      </div>

      <div className="cardBodyMulti">
        <div className="cardBodyMultiSection">
          <h2 className="cardBodyMultiAmount">
            ₹{data?.total ? Number(data.total).toLocaleString() : 0}
          </h2>
        </div>

        <div className="cardBodyMultiSection center">
          <div className="cardBodyMultiSectionPercentileIcon">
            <span
              className="cardBodyMultiSectionPercentile"
              style={{
                color: stringNumber < 0 ? "#EA2222" : "#05CD99",
              }}
            >
              {lastMonthGrowth || 0}%
            </span>
            <span className="cardBodyMultiSectionIcon">
              {stringNumber < 0 ? (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-caret-down-fill"
                  viewBox="0 0 16 16"
                  style={{ color: "#EA2222" }}
                >
                  <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" />
                </svg>
              ) : (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-caret-up-fill"
                  viewBox="0 0 16 16"
                >
                  <path d="m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z" />
                </svg>
              )}
            </span>
          </div>
          <span className="cardBodyMultiSectionSubtitle">Last month</span>
        </div>
      </div>
    </div>
  );
}

export default CardWithImage;
